import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  consignmentInformation: {
    id: 'consignment_info_panel.consignment_information',
    description: 'Consignment Information',
    defaultMessage: 'Consignment Information',
  },
  shipper: {
    id: 'consignment_info_panel.shipper',
    description: 'Shipper',
    defaultMessage: 'Shipper',
  },
  currency: {
    id: 'consignment_info_panel.currency',
    description: 'Currency',
    defaultMessage: 'Currency',
  },
  customerReferenceNumber: {
    id: 'consignment_info_panel.customer_reference_number',
    description: 'Customer Reference Number',
    defaultMessage: 'Customer Reference Number',
  },
  type: {
    id: 'consignment_info_panel.type',
    description: 'Type',
    defaultMessage: 'Type',
  },
  trackingNumber: {
    id: 'consignment_info_panel.tracking_number',
    description: 'Tracking Number (auto-generated)',
    defaultMessage: 'Tracking Number (auto-generated)',
  },
  description: {
    id: 'consignment_info_panel.description',
    description: 'Description',
    defaultMessage: 'Description',
  },
})
